import { render, staticRenderFns } from "./TunesGrantRewardEditor.vue?vue&type=template&id=4a5267e5&scoped=true"
import script from "./TunesGrantRewardEditor.vue?vue&type=script&lang=ts"
export * from "./TunesGrantRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5267e5",
  null
  
)

export default component.exports